<p (click)="logout()">BO dashboard works!</p>
